import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTimeRangePicker } from '@optios/react-date-time-range-picker'
import { Moment } from 'moment'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../App/Components/Button/Button'
import TopBar from '../../../../App/Components/TopBar/TopBar'
import TopBarButton from '../../../../App/Components/TopBar/TopBarButton/TopBarButton'

import { IProps } from './IProps'
import style from './style.scss'

export const DateRangeBar = ({
  isRangePickerVisible,
  setIsRangePickerVisible,
  startDateHook,
  endDateHook,
  setStartDateHook,
  setEndDateHook,
}: IProps) => {
  const { t } = useTranslation()
  const [changeCount, setChangeCount] = useState<number>(0)

  useEffect(() => {
    if (isRangePickerVisible) {
      setChangeCount(0)
    }
  }, [isRangePickerVisible])

  const onChange = (newStartDate: Moment, newEndDate: Moment) => {
    if (changeCount === 1) {
      setStartDateHook(newStartDate)
      setEndDateHook(newEndDate)
      setIsRangePickerVisible(false)
    } else {
      setChangeCount(changeCount + 1)
    }
  }

  const clearDateRange = () => {
    console.log('clear div')
    setIsRangePickerVisible(false)
  }

  return (
    <div>
      <div
        className={
          isRangePickerVisible
            ? style.rangeBackdropActive
            : style.rangeBackdropInactive
        }
        onClick={clearDateRange}
      />
      <TopBar>
        <TopBarButton href="/calendar">
          <FontAwesomeIcon icon={faTimes} />
        </TopBarButton>
        <div className={style.toolbar}>
          <button
            className={style.rangePickerBtn + ' ' + style.select}
            onClick={() => setIsRangePickerVisible(!isRangePickerVisible)}>
            {startDateHook && endDateHook
              ? `${startDateHook.format(
                  'dddd D MMMM YYYY',
                )} -  ${endDateHook.format('dddd D MMMM YYYY')}`
              : t('Customers in waiting list without date')}
          </button>
        </div>
        <div />
      </TopBar>
      {isRangePickerVisible ? (
        <div className={style.absolute}>
          <div className={style.rangePicker}>
            <DateTimeRangePicker
              range
              onChange={onChange}
              fromDate={startDateHook}
              untilDate={endDateHook}
            />
            <Button onClick={clearDateRange}>
              <FontAwesomeIcon icon={faTimes} /> {t('No date')}
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  )
}
